import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// PasswordGate (src/components/PasswordGate.tsx) previously wrapped the whole
// app here - a static, build-time shared password meant to keep casual
// visitors out of a throwaway preview before real auth existed. Now that
// Firebase Auth + SearchEntryAuthGuard gate real content, it's a redundant
// second password prompt in front of the real sign-in page - removed from
// the render tree. Left in the repo, unused, in case a future non-prod
// preview environment still wants a standalone access lock.
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
